module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-DB_1.f350be0e.jpg";